import { render } from "./DiagnosisRepairTask.vue?vue&type=template&id=5908a04f&scoped=true&ts=true&lang=pug"
import script from "./DiagnosisRepairTask.vue?vue&type=script&lang=ts"
export * from "./DiagnosisRepairTask.vue?vue&type=script&lang=ts"

import "./DiagnosisRepairTask.vue?vue&type=style&index=0&id=5908a04f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5908a04f"]])

export default __exports__